module.exports = __webpack_public_path__ + "img/Starter.d0564647.png";